import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import style from 'assets/css/View.module.css'
import { ReactComponent as IcoEdit } from 'assets/icons/options.svg'
import { Account, Role } from 'types'
import axiosClient from 'axios-client'
import Popup from 'components/Popup/Popup'
import TaskForm from 'views/tasks/form/TaskForm'
import CustomTag from 'components/Buttons/Tag/CustomTag'
import Modal from 'antd/es/modal/Modal'
import TopupForm from 'views/balance/TopupForm'
import { useStateContext } from 'context/ContextProvider'

export default function AccountView() {
  let { id } = useParams()
  const navigate = useNavigate()

  const { user } = useStateContext()

  // Button Menu
  const [showOption, setShowOption] = useState(false)
  const backdropRef = useRef<HTMLDivElement>(null)
  const handleClickOutside = (event: MouseEvent) => {
    if (backdropRef.current && !backdropRef.current.contains(event.target as HTMLDivElement)) {
      setShowOption(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [backdropRef])

  // Task Form
  const [showTaskForm, setShowTaskForm] = useState(false)
  const handleTaskForm = () => {
    setShowOption(false)
    setShowTaskForm(!showTaskForm)
  }

  // TopUp form
  const [showTopup, setShowTopup] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const handleTopupForm = () => {
    setShowOption(false)
    setShowTopup(!showTopup)
  }

  // Get account from api
  const [account, setAccount] = useState<Account>()
  useEffect(() => {
    axiosClient.get(`/accounts/${id}`).then(({ data }) => {
      setAccount({ ...data })
    })
  }, [])

  if (!account) {
    return <></>
  }

  return (
    <>
      <div className={`${style.title}`}>
        <div>Account details</div>

        <IcoEdit
          className={`${style.edit}`}
          onClick={() => setShowOption(true)}
        />
        {showOption && (
          <>
            <div
              ref={backdropRef}
              className={`${style.buttonMenu}`}
            >
              {[Role.Admin, Role.Manager].some(value => user?.roles.includes(value)) && (
                <div
                  className={`${style.editButton}`}
                  onClick={() => navigate('/accounts/' + id)}
                >
                  Edit Account
                </div>
              )}

              <div
                className={`${style.addButton}`}
                onClick={handleTaskForm}
              >
                Add Task
              </div>
              <div
                className={`${style.addButton}`}
                onClick={handleTopupForm}
              >
                Add Top up
              </div>
            </div>
          </>
        )}
      </div>
      <div className={`${style.data}`}>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Client Name</div>
          <div className={`${style.info}`}>{account.client?.name}</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Plateform</div>
          <CustomTag>{account.platform}</CustomTag>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Country</div>
          <div className={`${style.info}`}>{account.country}</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Phone Number</div>
          <div className={`${style.info}`}>{account.phone}</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Email</div>
          <div className={`${style.info}`}>{account.email}</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Account ID</div>
          <div className={`${style.info}`}>{account.username}</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Password</div>
          <div className={`${style.info}`}>{account.password}</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Website</div>
          <div className={`${style.info}`}>{account.website}</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Shared ON</div>
          <div className={`${style.info}`}>{account.sharedon}</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Commission</div>
          <div className={`${style.info}`}>{account.commission}%</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>API Key</div>
          <div className={`${style.info}`}>{account.apikey}</div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Proxy</div>
          <div className={`${style.download}`}>
            <div className={`${style.pdf_name}`}>{account.proxy}</div>
          </div>
        </div>
        <div className={`${style.data_container}`}>
          <div className={`${style.label}`}>Status</div>
          <CustomTag>{account.status}</CustomTag>
        </div>
      </div>

      <Modal
      width={1000}
      title="Top up account"
      open={showTaskForm}
      onCancel={handleTaskForm}
      footer={null}
      >
<TaskForm
            taskable={{ id: account.id.toString(), name: account.username, type: account.type }}
            closePopup={handleTaskForm}
          />
      </Modal>

      <Modal
        width={'fit-content'}
        title="Top up account"
        open={showTopup}
        onCancel={handleTopupForm}
        footer={null}
      >
        <TopupForm topupLink={account} closePopup={handleTopupForm} />
      </Modal>
    </>
  )
}
